import * as angular from "angular";
import * as _ from "lodash";
import {HolderType} from "../commons/types/holder.type";
import {LogisticsVehicleService} from "./services/logistics-vehicle-service.service";
import {QuickFilterContextService} from "../commons/services/quick-filter-context.service";
import {SettingsService} from "../site-preferences/services/settings-service.service";
import {ViewFilterSettingsService} from "../commons/services/view-filter-settings.service";
import {CommonsService} from "../commons/services/commons-service.service";
import {LOGISTICS_VEHICLES_IMPORT_CONFIG} from "./constants/logistics-vehicles-import.const";

angular
  .module('bringoz.admin.logistics-vehicle')
  .config(logisticsVehicleConfig);

/* @ngInject */
function logisticsVehicleConfig($stateProvider) {

  $stateProvider
    .state('logistics-vehicles-list', {
      parent: 'bringoz.site',
      url: '/logistics-vehicles?:query&:vehicleTypeIds&:vehicleTypes&:branchIds&:status',
      template: '<logistics-vehicles-list-view query="vm.query" vehicle-type-ids="vm.vehicleTypeIds" vehicle-types="vm.vehicleTypes" ' +
        'branch-ids="vm.branchIds" status="vm.status" selected-quick-filter-id="vm.selectedQuickFilterId"></logistics-vehicles-list-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, $stateParams, quickFilterContextService: QuickFilterContextService, viewFilterSettingsService: ViewFilterSettingsService, $state, commonsService: CommonsService, site) {

        const quickActiveFilter = viewFilterSettingsService.getActiveQuickFilter($state.current.name);

        this.selectedQuickFilterId = quickActiveFilter?.id;
        this.query = $stateParams.query;
        this.vehicleTypeIds = commonsService.parseArrayStateParam($stateParams.vehicleTypeIds) || quickActiveFilter?.settings.vehicleTypeIds;
        this.vehicleTypes = commonsService.parseArrayStateParam($stateParams.vehicleTypes) || quickActiveFilter?.settings.vehicleTypes;
        this.branchIds = commonsService.parseArrayStateParam($stateParams.branchIds) || quickActiveFilter?.settings.branchIds || viewFilterSettingsService.getBranchIds() || [];;
        this.status = $stateParams.status || quickActiveFilter?.settings.logisticsVehicleStatus;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Logistic Vehicles"});
        triBreadcrumbsService.addCrumb({name: 'Fleet Management'});
        triBreadcrumbsService.addCrumb({name: 'Resources'});

      }
    })

    //Logistic vehicles file upload
    .state('logistics-vehicles-upload', {
      parent: 'bringoz.site',
      url: '/logistics-vehicles-upload',
      template: '<logistics-vehicles-import-view></logistics-vehicles-import-view>',
      controller: function (triBreadcrumbsService, $state, IAMPermissions) {
        // Importing needs create, and following the batch needs list as well.
        const requiredPermissions = [...LOGISTICS_VEHICLES_IMPORT_CONFIG.permissions,
          LOGISTICS_VEHICLES_IMPORT_CONFIG.statusPermission];
        const hasImportPermission = _.every(requiredPermissions,
          (permission: string) => IAMPermissions.hasPermission(permission));

        if (!hasImportPermission) {
          $state.go('logistics-vehicles-list');
          return;
        }

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Upload Logistic Vehicles'});
        triBreadcrumbsService.addCrumb({name: 'Logistic Vehicles', state: 'logistics-vehicles-list'});
        triBreadcrumbsService.addCrumb({name: 'Fleet Management'});
        triBreadcrumbsService.addCrumb({name: 'Resources'});
      }
    })

    //Logistic vehicle details
    .state('logistics-vehicle', {
      parent: 'bringoz.site',
      url: '/logistics-vehicle/:id',
      abstract: true,
      template: '<logistics-vehicle-detailed-view logistics-vehicle="logisticsVehicle"></logistics-vehicle-detailed-view>',
      controller: function ($scope, $logisticsVehicle, triBreadcrumbsService, logisticsVehicle, site) {

        $scope.logisticsVehicle = logisticsVehicle;

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: logisticsVehicle.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Vehicles', state: 'logistics-vehicles-list'});
        triBreadcrumbsService.addCrumb({name: 'Fleet Management'});
        triBreadcrumbsService.addCrumb({name: 'Resources'});
      },
      resolve: {
        logisticsVehicle: function (agentRequests, $logisticsVehicle, $stateParams, site) {
          return $logisticsVehicle($stateParams.id).$instantGet();
        }
      }
    })

    //  Profile - Main
    .state('logistics-vehicle.vehicle-profile', {
      url: '/profile',
      pageTrack: '/logistics-vehicle/profile',
      template: '<logistics-vehicle-profile logistics-vehicle="$ctrl.logisticsVehicle"></logistics-vehicle-profile>'
    })

    .state('logistics-vehicle.documents-and-reminders', {
      url: '/documents-and-reminders',
      pageTrack: '/logistics-vehicle/documents-and-reminders',
      template: '<logistics-vehicle-documents-and-reminders logistics-vehicle="$ctrl.logisticsVehicle"' +
        ' documents-settings="documentsSettings" documents="documents" reminders-settings="remindersSettings"' +
        ' reminders="reminders"></logistics-vehicle-documents-and-reminders>',
      controller: function ($scope, logisticsVehicle, documentsSettings, documents, remindersSettings, reminders) {
        $scope.documentsSettings = documentsSettings;
        $scope.documents = documents;

        $scope.remindersSettings = remindersSettings;
        $scope.reminders = reminders;

      },
      resolve: {
        documentsSettings: function (settingsService: SettingsService, site) {
          return settingsService.getAllDocuments(HolderType.VEHICLE)
        },
        documents: function (logisticsVehicleService: LogisticsVehicleService, logisticsVehicle, site) {
          return logisticsVehicleService.getDocuments(logisticsVehicle.id)
        },
        remindersSettings: function (settingsService: SettingsService, site) {
          return settingsService.getAllReminders(HolderType.VEHICLE)
        },
        reminders: function (logisticsVehicleService: LogisticsVehicleService, logisticsVehicle, site) {
          return logisticsVehicleService.getReminders(logisticsVehicle.id)
        },
      },

    })

}
